import { readConsent } from './consent';
export const MEASUREMENT_ID = 'G-DZTSRCQEGE';
let initialized = false;
let lastPage = null;
const production = () => process.env.REACT_APP_IS_PRODUCTION === '1' && /^(www\.)?standard\.gm$/.test(window.location.hostname);
function clearCookies() {
  for (const part of document.cookie.split(';')) {
    const name = part.trim().split('=')[0];
    if (!/^_ga(?:_|$)/.test(name)) continue;
    for (const domain of ['', window.location.hostname, '.standard.gm']) {
      document.cookie = `${name}=; Max-Age=0; path=/;${domain ? ` domain=${domain};` : ''} SameSite=Lax`;
    }
  }
}
export function updateAnalyticsConsent(allowed) {
  if (!production()) return;
  window['ga-disable-' + MEASUREMENT_ID] = !allowed;
  if (!allowed) {
    lastPage = null;
    if (initialized) window.gtag('consent', 'update', { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
    clearCookies();
    return;
  }
  if (!initialized) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('consent', 'default', { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
    window.gtag('consent', 'update', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
    window.gtag('js', new Date());
    window.gtag('config', MEASUREMENT_ID, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false });
    const script = document.createElement('script');
    script.id = 'standard-ga4'; script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + MEASUREMENT_ID;
    document.head.appendChild(script);
    initialized = true;
  } else window.gtag('consent', 'update', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
}
export function trackPage(pathname) {
  if (!production() || !readConsent()?.analytics || !initialized || window['ga-disable-' + MEASUREMENT_ID]) return;
  const location = window.location.origin + pathname;
  if (lastPage === location) return;
  window.gtag('event', 'page_view', { send_to: MEASUREMENT_ID, page_location: location, page_title: document.querySelector('main h1')?.textContent || document.title, page_referrer: lastPage || document.referrer });
  lastPage = location;
}
